import { Outlet, useLocation } from 'react-router-dom'
// material
import { styled, useTheme } from '@material-ui/core/styles'
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer'
//
import DashboardNavbar from './DashboardNavbar'
// import DashboardSidebar from './DashboardSidebar'

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 32

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
})

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  // A flex item defaults to min-width: auto, so a wide table (minWidth on the
  // table) would stretch the page past the viewport. 0 lets each table scroll
  // inside its own container instead.
  minWidth: 0,
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: 0,
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}))

// Full-screen routes (no navbar, only a small floating back button).
// Used by the unified genome browser where every pixel of vertical real
// estate matters — Home/Files/Admin/profile/notifications/etc collapse
// to a single 36 px back affordance in the top-left corner.
const FULL_SCREEN_PATTERNS = [/^\/libra\/unified\//]

const FullScreenMain = styled('div')({
  flexGrow: 1,
  minWidth: 0,
  minHeight: '100vh',
  width: '100%',
  padding: 0,
})

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme()
  const { collapseClick } = useCollapseDrawer()
  const location = useLocation()

  const isFullScreen = FULL_SCREEN_PATTERNS.some((re) => re.test(location.pathname))

  if (isFullScreen) {
    // No navbar. The view itself is responsible for surfacing a back
    // affordance somewhere inside its own chrome (e.g. as the leading
    // element of its title row) so we don't waste a 40 px corner on a
    // floating button that overlaps the page heading.
    return (
      <RootStyle>
        <FullScreenMain>
          <Outlet />
        </FullScreenMain>
      </RootStyle>
    )
  }

  return (
    <RootStyle>
      <DashboardNavbar />
      {/* <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} /> */}
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex,
          }),
          ...(collapseClick &&
            {
              //ml: '102px',
            }),
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  )
}
